import { IUpdateRequisicaoCompraProdutoServicoUseCase } from "../../../presentation/useCases/update/update_requisicao_compra_produto_servico_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * UpdateRequisicaoCompraProdutoServicoUseCase
 */

export class UpdateRequisicaoCompraProdutoServicoUseCase implements IUpdateRequisicaoCompraProdutoServicoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async updateRequisicaoCompraProdutoServico(
    idRequisicaoProdutoServico: number,
    idProdutoServico: number,
    idSubconta: number | null,
    quantidade: number,
  ): Promise<void> {
    await this.repository.updateRequisicaoCompraProdutoServico(
      idRequisicaoProdutoServico,
      idProdutoServico,
      idSubconta,
      quantidade,
    );
  }
}
